module.exports = __webpack_public_path__ + "static/CSF1-d735cf77499623ef56dde212c9848428.png";